// Listeners helper
export class Listeners {
  constructor() {
    this.entries = [];
  }

  add(element, event, fn) {
    if (typeof element === 'string') {
      const elements = document.querySelectorAll(element);
      elements.forEach((el) => {
        this.entries.push({
          element: el,
          event,
          fn,
        });
        el.addEventListener(event, fn);
      });
    } else {
      this.entries.push({
        element,
        event,
        fn,
      });
      element.addEventListener(event, fn);
    }
  }

  remove(element, event) {
    this.entries = this.entries.filter((listener) => {
      if (listener.element === element && listener.event === event) {
        listener.element.removeEventListener(listener.event, listener.fn);
        return false;
      }
    });
  }

  removeAll() {
    this.entries = this.entries.filter((listener) => {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  }
}

export function loadScript(src, onLoadSuccessCallback, onLoadErrorCallback) {
  if (!src) {       
    if (typeof Bugsnag !== 'undefined') Bugsnag.notify(new Error('Error: missing src'));
    return;
  }

  // Check if the script is already loaded
  if (document.querySelector('script[src="' + src + '"]')) {
    // Script already loaded...
    onLoadSuccessCallback();
  } else {
    // Script not already leaded; load script...
    // Create script tag
    const js = document.createElement("script");
    js.src = src;
    if (src.includes('zdassets')) js.id = 'ze-snippet';
    js.setAttribute("async", "");

    // Setup success callback
    if (onLoadSuccessCallback) {
      js.onload = onLoadSuccessCallback;
    }

    // Setup error callback
    if (onLoadErrorCallback) {
      js.onerror = onLoadErrorCallback;
    }

    // Add the script tag to <head>
    document.head.appendChild(js);
  }
}

export async function loadCSS(src, onLoadSuccessCallback, onLoadErrorCallback) {
  if (!src) {       
    if (typeof Bugsnag !== 'undefined') Bugsnag.notify(new Error('Error: missing src'));
    return;
  }

  // Check if the script is already loaded
  if (document.querySelector('link[href="' + src + '"]')) {
    // Script already loaded...
    onLoadSuccessCallback();
  } else {
    // Script not already leaded; load script...
    const head = document.getElementsByTagName('HEAD')[0];
    const link = document.createElement('link');

    // set the attributes for link element
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = src;

    // Append link element to HTML head
    head.appendChild(link);

    // Setup success callback
    if (onLoadSuccessCallback) {
      link.onload = onLoadSuccessCallback;
    }

    // Setup error callback
    if (onLoadErrorCallback) {
      link.onerror = onLoadErrorCallback;
    }
  }
}

export function ifIntersectionObserverSupported() {
  return ('IntersectionObserver' in window);
  // if (!('IntersectionObserver' in window) &&
  //   !('IntersectionObserverEntry' in window) &&
  //   !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) return console.warn('IntersectionObserver not supported');
}

export function onSortGoTo(target, callback, behavior = 'smooth') {
  const onSortScrollTo = target || document.querySelector('#onSortScrollTo');
  const siteHeader = document.querySelector('.site-header');
  if (!onSortScrollTo || !siteHeader) return;

  const requestedTop = Math.floor(window.scrollY + (onSortScrollTo.getBoundingClientRect().top - siteHeader.getBoundingClientRect().height));
  const onScroll = () => {
    if (Math.floor(window.scrollY) === requestedTop) {
      window.removeEventListener('scroll', onScroll);

      const checkRequestTop = Math.floor(window.scrollY + (onSortScrollTo.getBoundingClientRect().top - siteHeader.getBoundingClientRect().height));
      if (requestedTop === checkRequestTop) return;

      window.scrollTo({
        top: checkRequestTop, 
        behavior
      });
    }
  }

  window.addEventListener('scroll', onScroll);

  window.scrollTo({
    top: window.scrollY + (onSortScrollTo.getBoundingClientRect().top - siteHeader.getBoundingClientRect().height), 
    behavior
  });
}

// export function fadeIn(elem) {
//   const current = Number(getComputedStyle(elem).opacity);
//   if (current >= 1) return;

//   elem.style.opacity = current + 0.05;
//   setTimeout(function () {
//     fadeIn(elem);
//   }, 10);
// }

// export function fadeOut(elem) {
//   const current = Number(getComputedStyle(elem).opacity);
//   if (current <= 0) return;

//   elem.style.opacity = current - 0.05;
//   setTimeout(function () {
//     fadeOut(elem);
//   }, 10);
// }

// if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
//   module.exports = sliderArrows;
//   module.exports = sliderDots;
//   module.exports = sliderAutoPlay;
// } else {
//   window.sliderArrows = sliderArrows;
//   window.sliderDots = sliderDots;
//   window.sliderAutoPlay = sliderAutoPlay;
// }

export function stripHtml(string) {
  if (typeof string === 'string' || string instanceof String) {
    const doc = new DOMParser().parseFromString(string, 'text/html');
    return doc.body.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ') || '';
  } else {
    return string.textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ') || '';
  }
}

export function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

export function throttle(fn, delay = 300) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = (amount, format = window.Shopify.money_format) => {
  const formatNumber = (num, decimals = 2, thousandsSep = ',', decimalSep = '.') => {
      if (isNaN(num) || num == null) return '0';

      num = (num / 100).toFixed(decimals);
      const [intPart, decimalPart] = num.split('.');

      return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep) + (decimalPart ? decimalSep + decimalPart : '');
  };

  if (typeof amount === 'string') amount = amount.replace('.', '');
  
  const formatTypes = {
      amount: () => formatNumber(amount, 2),
      amount_no_decimals: () => formatNumber(amount, 0),
      amount_with_comma_separator: () => formatNumber(amount, 2, '.', ','),
      amount_with_space_separator: () => formatNumber(amount, 2, ' ', ','),
      amount_with_period_and_space_separator: () => formatNumber(amount, 2, ' ', '.'),
      amount_no_decimals_with_comma_separator: () => formatNumber(amount, 0, '.', ','),
      amount_no_decimals_with_space_separator: () => formatNumber(amount, 0, ' '),
      amount_with_apostrophe_separator: () => formatNumber(amount, 2, '\'', '.'),
  };

  const formatKey = format.match(/\{\{\s*(\w+)\s*\}\}/)?.[1];
  return format.replace(/\{\{\s*\w+\s*\}\}/, formatTypes[formatKey] ? formatTypes[formatKey]() : '0');
};

export function formatMoney(value, format = 'amount') {
  if (window.Shopify) {
    const inFrontSymbols = '£$€';
    const symbol = window.Shopify.currency.symbol;
    const formatCustom = (inFrontSymbols.includes(symbol)) ? `${symbol}{{${format}}}` : `{{${format}}} ${symbol}`;
    return window.Shopify.formatMoney(value, formatCustom);
  }

  return value;
}

export const getSiblings = (elm, withTextNodes) => {
  if( !elm || !elm.parentNode ) return
  
  const siblings = [...elm.parentNode[withTextNodes ? 'childNodes' : 'children']];
  const idx = siblings.indexOf(elm);
  
  siblings.before = siblings.slice(0, idx);
  siblings.after = siblings.slice(idx + 1);
  
  return siblings
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  const name = cname + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * Various DOM helper
 */
export class Dom {
  static getSiblings(element, filter) {
    var includeSelf =
      arguments.length > 2 && arguments[2] !== undefined
        ? arguments[2]
        : false;
    var siblings = [];
    var currentElement = element; // Do the previous first

    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    } // Then the next side

    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }
}

// Responsive helper
export class Responsive {
  static matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;
      case "tablet":
        return window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches;
      case "tablet-up":
        return window.matchMedia("screen and (min-width: 641px)").matches;
      case "pocket":
        return window.matchMedia("screen and (max-width: 1023px)").matches;
      case "lap":
        return window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches;
      case "lap-up":
        return window.matchMedia("screen and (min-width: 1024px)").matches;
      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
      case "widescreen":
        return window.matchMedia("screen and (min-width: 1440px)").matches;
      case "supports-hover":
        return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    }
  }
  static getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }
    if (window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches) {
      return "tablet";
    }
    if (window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches) {
      return "lap";
    }
    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}

// Animation helper
var animationQueue = {};
export class Animation {
  /**
   * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
   * force an animation
   */
  static slideUp(element, callback, propertyToAnimate = "height") {
    element.style[propertyToAnimate] = `${element.scrollHeight}px`;
    element.offsetHeight;
    element.style[propertyToAnimate] = 0;
    if (animationQueue[element.id]) {
      element.removeEventListener("transitionend", animationQueue[element.id]);
    }
    if (callback) {
      animationQueue[element.id] = callback;
      element.addEventListener("transitionend", callback);
    }
  }
  /**
   * Slide down aims to open an element. To do that, we set the height to 0, then to the scrollHeight to
   * force an animation
   */
  static slideDown(element, callback, propertyToAnimate = "height") {
    element.style[propertyToAnimate] = 0;
    element.offsetHeight;
    element.style[propertyToAnimate] = `${element.scrollHeight}px`;
    if (animationQueue[element.id]) {
      element.removeEventListener("transitionend", animationQueue[element.id]);
    }
    if (callback) {
      animationQueue[element.id] = callback;
      element.addEventListener("transitionend", callback);
    }
  }
}

// Accessibility helper
export class Accessibility {
  /**
   * Traps the focus in a particular container
   */
  static trapFocus(container, namespace) {
    this.listeners = this.listeners || {};
    let elementToFocus = container.querySelector("[autofocus]") || container;
    container.setAttribute("tabindex", "-1");
    elementToFocus.focus();
    this.listeners[namespace] = (event2) => {
      if (container !== event2.target && !container.contains(event2.target)) {
        elementToFocus.focus();
      }
    };
    document.addEventListener("focusin", this.listeners[namespace]);
  }
  /**
   * Removes the trap of focus in a particular container
   */
  static removeTrapFocus(container, namespace) {
    if (container) {
      container.removeAttribute("tabindex");
    }
    document.removeEventListener("focusin", this.listeners[namespace]);
  }
  /**
   * Reset any previous trap focus
   */
  static clearTrapFocus() {
    for (let key in this.listeners) {
      if (this.listeners.hasOwnProperty(key)) {
        document.removeEventListener("focusin", this.listeners[key]);
      }
    }
    this.listeners = {};
  }
}

// Form helper
export class Form {
  static serialize(form) {
    function stringKey(key, value) {
      let beginBracket = key.lastIndexOf("[");
      if (beginBracket === -1) {
        let hash2 = {};
        hash2[key] = value;
        return hash2;
      }
      let newKey = key.substr(0, beginBracket);
      let newValue = {};
      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
      return stringKey(newKey, newValue);
    }
    let hash = {};
    for (let i = 0, len = form.elements.length; i < len; i++) {
      let formElement = form.elements[i];
      if (formElement.name === "" || formElement.disabled) {
        continue;
      }
      if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
        let stringKeys = stringKey(formElement.name, formElement.value);
        hash = Form.extend(hash, stringKeys);
      }
    }
    return hash;
  }
  static extend() {
    let extended = {};
    let i = 0;
    let merge = function(obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = Form.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }
    return extended;
  }
}

// Enhanced preloading utilities using instant.page functions
export class PreloadManager {
  constructor() {
    this.preloadedUrls = new Set();
    this.preloadedImages = new Set();
  }

  /**
   * Preload a URL using instant.page's preload function
   * @param {string} url - URL to preload
   * @param {string} priority - 'high', 'low', or 'auto'
   */
  preloadUrl(url, priority = 'auto') {
    if (this.preloadedUrls.has(url)) {
      return;
    }

    // Use instant.page preload function if available
    if (window.preload && typeof window.preload === 'function') {
      window.preload(url, priority);
    } else {
      // Fallback to manual preload
      this.manualPreload(url, priority);
    }

    this.preloadedUrls.add(url);
  }

  /**
   * Manual preload implementation as fallback
   * @param {string} url - URL to preload
   * @param {string} priority - Priority level
   */
  manualPreload(url, priority = 'auto') {
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.fetchPriority = priority;
    link.as = 'document';
    document.head.appendChild(link);
  }

  /**
   * Preload an image
   * @param {string} imageUrl - Image URL to preload
   * @param {string} priority - Priority level
   */
  preloadImage(imageUrl, priority = 'auto') {
    if (this.preloadedImages.has(imageUrl)) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = imageUrl;
    link.as = 'image';
    link.fetchPriority = priority;
    document.head.appendChild(link);

    this.preloadedImages.add(imageUrl);
  }

  /**
   * Preload multiple URLs
   * @param {string[]} urls - Array of URLs to preload
   * @param {string} priority - Priority level
   */
  preloadMultiple(urls, priority = 'auto') {
    urls.forEach(url => this.preloadUrl(url, priority));
  }

  /**
   * Preload product images from a collection
   * @param {string} collectionHandle - Collection handle
   * @param {number} limit - Number of products to preload
   */
  async preloadCollectionImages(collectionHandle, limit = 5) {
    try {
      const response = await fetch(`/collections/${collectionHandle}.json?limit=${limit}`);
      const data = await response.json();
      
      data.products.forEach(product => {
        if (product.featured_image) {
          this.preloadImage(product.featured_image, 'low');
        }
      });
    } catch (error) {
      // Silent error handling
    }
  }

  /**
   * Preload critical navigation links
   */
  preloadNavigation() {
    const navLinks = document.querySelectorAll('nav a[href^="/"]');
    navLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && !href.includes('#') && !this.preloadedUrls.has(href)) {
        this.preloadUrl(href, 'low');
      }
    });
  }

  /**
   * Preload based on user behavior (hover, focus)
   * @param {Element} element - Element to attach listeners to
   * @param {string} url - URL to preload
   */
  attachSmartPreload(element, url) {
    if (!element || !url) return;

    const preloadHandler = () => this.preloadUrl(url, 'high');
    
    element.addEventListener('mouseenter', preloadHandler, { passive: true });
    element.addEventListener('touchstart', preloadHandler, { passive: true });
    element.addEventListener('focus', preloadHandler, { passive: true });
  }
}

// Global preload manager instance
window.preloadManager = new PreloadManager();

// Secure localStorage utilities with cookie fallback
export class SecureStorage {
  /**
   * Check if localStorage is available and accessible
   * @returns {boolean} True if localStorage is available
   */
  static isAvailable() {
    try {
      const test = '__localStorage_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Safely get item from localStorage with cookie fallback
   * @param {string} key - Storage key
   * @param {string} defaultValue - Default value if key doesn't exist or storage unavailable
   * @returns {string|null} Stored value or default
   */
  static getItem(key, defaultValue = null) {
    // Try localStorage first
    if (this.isAvailable()) {
      try {
        const value = localStorage.getItem(key);
        if (value !== null) {
          return value;
        }
      } catch (e) {
        console.warn('localStorage getItem failed:', e);
      }
    }

    // Fallback to cookies
    try {
      const cookieValue = this._getCookie(key);
      return cookieValue || defaultValue;
    } catch (e) {
      console.warn('Cookie fallback failed:', e);
      return defaultValue;
    }
  }

  /**
   * Safely set item in localStorage with cookie fallback
   * @param {string} key - Storage key
   * @param {string} value - Value to store
   * @returns {boolean} True if successful, false otherwise
   */
  static setItem(key, value) {
    // Try localStorage first
    if (this.isAvailable()) {
      try {
        localStorage.setItem(key, value);
        return true;
      } catch (e) {
        console.warn('localStorage setItem failed:', e);
      }
    }

    // Fallback to cookies
    try {
      this._setCookie(key, value, 30); // 30 days expiration
      return true;
    } catch (e) {
      console.warn('Cookie fallback failed:', e);
      return false;
    }
  }

  /**
   * Safely remove item from localStorage and cookies
   * @param {string} key - Storage key
   * @returns {boolean} True if successful, false otherwise
   */
  static removeItem(key) {
    let success = false;

    // Try localStorage first
    if (this.isAvailable()) {
      try {
        localStorage.removeItem(key);
        success = true;
      } catch (e) {
        console.warn('localStorage removeItem failed:', e);
      }
    }

    // Also remove from cookies
    try {
      this._setCookie(key, '', -1); // Expire immediately
      success = true;
    } catch (e) {
      console.warn('Cookie removal failed:', e);
    }

    return success;
  }

  /**
   * Safely get JSON object from localStorage with cookie fallback
   * @param {string} key - Storage key
   * @param {any} defaultValue - Default value if key doesn't exist or storage unavailable
   * @returns {any} Parsed JSON or default value
   */
  static getJSON(key, defaultValue = null) {
    const item = this.getItem(key);
    if (item === null || item === undefined) {
      return defaultValue;
    }

    try {
      return JSON.parse(item);
    } catch (e) {
      console.warn('JSON parse failed:', e);
      return defaultValue;
    }
  }

  /**
   * Safely set JSON object in localStorage with cookie fallback
   * @param {string} key - Storage key
   * @param {any} value - Value to store as JSON
   * @returns {boolean} True if successful, false otherwise
   */
  static setJSON(key, value) {
    try {
      return this.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.warn('JSON stringify failed:', e);
      return false;
    }
  }

  /**
   * Private method to get cookie value
   * @param {string} name - Cookie name
   * @returns {string|null} Cookie value or null
   */
  static _getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }

  /**
   * Private method to set cookie
   * @param {string} name - Cookie name
   * @param {string} value - Cookie value
   * @param {number} days - Expiration days
   */
  static _setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    // Limit cookie size to 4KB and encode value
    const cookieValue = encodeURIComponent(value).substring(0, 4000);
    document.cookie = name + "=" + cookieValue + expires + "; path=/; SameSite=Lax";
  }
}